import styled from 'styled-components'

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;
`

export const LoadingWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 340px;
  padding: 1rem;
`

export const AutoCompleteWrapper = styled.div`
  min-width: 440px;
  max-width: 33%;

  @media (max-width: 768px) {
    min-width: 0;
    max-width: 100%;
  }
`

export const RecommendationsSection = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  gap: 0.5rem;
  padding: 0.25rem;
`

export const ProceduresGrid = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  gap: 1rem;
  width: 100%;
  padding: 0.25rem;

  @media (min-width: 768px) {
    grid-template-columns: repeat(3, 1fr);
  }
`

export const TableSection = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  margin-top: 2rem;
`

export const AddButton = styled.div`
  display: flex;
  justify-content: flex-start;
  margin-top: 0.5rem;

  svg {
    width: 10px;
    height: 10px;
  }
`
